import * as React from 'react';
import { MailLinkAction } from '../../model/Action';
import { MachineContext } from '../fsm/useMachine';
import guidGenerator from '../utils/commonFunctions';
import { LinkProps } from './LinkScreen';

export const MailLink: React.FC<LinkProps<MailLinkAction>> = ({ set_action, existing }) => {
    const [, send] = React.useContext(MachineContext)

    const formAction = (e: React.ChangeEvent<HTMLInputElement>) => {
        send({ type: "MARK_ACTIVE", id: e.currentTarget.id })
        const action = new MailLinkAction(e.currentTarget.value)
        set_action({ __tag: "email", value: action })
    }

    return (
        <React.Fragment>
            <div className="linkMenu-desc">
                <h3>Set Email Link</h3>
                <p>Clicking this item will compose an email to the address below.</p>
            </div>
            <input
                type="text"
                placeholder="Enter an Email Address..."
                defaultValue={
                    existing != undefined ? existing.weblink.replace("mailto:", "") : ""
                }
                onChange={formAction}
                id={guidGenerator()}
                className="linkInput"
            />
        </React.Fragment>
    )
}